// import Http from '../API'

export default {
  state: {
    countdown: 1, //системное

    ticket_list_update: 60,

    device_profile_update: 15,
    device_log_update: 30,
    device_selftest_result: 10,
    device_statistic_status: 60,
    device_simcard_update: 15,
    device_group_list_update: 30,
    device_list_update: 30,

    history_action_update: 30,

    simcard_devices_profile_update: 15,
    simcard_devices_group_update: 30,
    simcard_devices_list_update: 30,

    esim_profile_update: 15,
    esim_actions_update: 5,
    esim_actions_history: 30,
    esim_group_update: 30,
    esim_list_update: 30,

    simcard_profile_profile_update: 15,
    simcard_profile_actions_update: 5,
    simcard_profile_actions_history: 30,
    simcard_profile_group_update: 30,
    simcard_profile_list_update: 30,

    check_rpc_command: 5,
    ping_ssh: 30,
  },
  getters: {

    // Вызов интервала в 1 секунду
    getCountdown: (state) => {
      return state.countdown*1000
    },

    // Вызов интервала для тикетов
    getTicketListUpdate: (state) => {
      return state.ticket_list_update*1000
    },

    //Вызов Модемных интвервалов
    getDeviceProfileUpdate: (state) => {
      return state.device_profile_update*1000
    },
    getDeviceLogUpdate: (state) => {
      return state.device_log_update*1000
    },
    getDeviceSelftestResult: (state) => {
      return state.device_selftest_result*1000
    },
    getDeviceStatisticStatus: (state) => {
      return state.device_statistic_status*1000
    },
    getDeviceSimcardUpdate: (state) => {
      return state.device_simcard_update*1000
    },
    getDeviceGroupListUpdate: (state) => {
      return state.device_group_list_update*1000
    },
    getDeviceListUpdate: (state) => {
      return state.device_list_update*1000
    },

    //Вызов интервалов связанных с Simcard Devices
    getSimcardDevicesProfileUpdate: (state) => {
      return state.simcard_devices_profile_update*1000
    },
    getSimcardDevicesGroupUpdate: (state) => {
      return state.simcard_devices_group_update*1000
    },
    getSimcardDevicesListUpdate: (state) => {
      return state.simcard_devices_list_update*1000
    },

    //Вызов интервало связанных с историей действий для симкарт и девайсов
    getHistoryActionUpdate: (state) => {
      return state.history_action_update*1000
    },

    //Вызов интервалов связанных с Esim Profile
    getEsimProfileUpdate: (state) => {
      return state.esim_profile_update*1000
    },
    getEsimActionsUpdate: (state) => {
      return state.esim_actions_update*1000
    },
    getEsimActionsHistory: (state) => {
      return state.esim_actions_history*1000
    },
    getEsimGroupUpdate: (state) => {
      return state.esim_group_update*1000
    },
    getEsimListUpdate: (state) => {
      return state.esim_list_update*1000
    },

    //Вызов интервалов связанных с Simcard Profile
    getSimcardProfileProfileUpdate: (state) => {
      return state.simcard_profile_profile_update*1000
    },
    getSimcardProfileActionsUpdate: (state) => {
      return state.simcard_profile_actions_update*1000
    },
    getSimcardProfileActionsHistory: (state) => {
      return state.simcard_profile_actions_history*1000
    },
    getSimcardProfileGroupUpdate: (state) => {
      return state.simcard_profile_group_update*1000
    },
    getSimcardProfileListUpdate: (state) => {
      return state.simcard_profile_list_update*1000
    },

    //Интерваля для проверки RPC
    getCheckRpcCommand: (state) => {
      return state.check_rpc_command*1000
    },

    //Интерваля для отправки ping
    getPingSsh: (state) => {
      return state.ping_ssh*1000
    },
  },
  mutations: {
    setGlobalTiming(state, global_timings) {
      for (let item of Object.keys(global_timings)) {
        state[item] = global_timings[item]
      }
    },
  },
  actions: {
    setGlobalTiming (context, obj) {
      context.commit('setGlobalTiming', obj)
    },
  }
}
